import { render, staticRenderFns } from "./HealthCheck25PsaThyroidNR.vue?vue&type=template&id=88f1ee2e&scoped=true&"
import script from "./HealthCheck25PsaThyroidNR.vue?vue&type=script&lang=js&"
export * from "./HealthCheck25PsaThyroidNR.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck25PsaThyroidNR.vue?vue&type=style&index=0&id=88f1ee2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f1ee2e",
  null
  
)

export default component.exports